import { createAsyncThunk } from '@reduxjs/toolkit';

import { APIAclConditionGetList } from './AclConditions.api';

export const fetchAclConditions = createAsyncThunk('aclConditions/fetchAclConditions', async (item: { key: string, signal?: AbortSignal }) => {
    const response = await APIAclConditionGetList(item);
    return response.data;
});
